module.exports = __webpack_public_path__ + "img/icon-preapproval letter.0b5816b4.svg";